import React, { Component } from "react";
import { alertActions } from '../../action/AlertAction';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { loginActions } from "../../action/loginAction";
import { gameActions } from "../../action/GameAction";
import { history } from "../../helpers/history";
import { appVariables } from "../../helpers/appVariables";
import { Helmet } from "react-helmet";
class Changepassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentpwd: '',
            newpwd: '',
            confirmpwd: '',
            showoldpwd: false,
            shownewpwd: false,
            showconfrimpwd: false,
            lottoType: props.lottotype,
            showdDeleteMsg: false,
            creditStatus: 0,
            ShowErrorMsgCurr: "",
            ShowErrorMsgNew: "",
            ShowErrorMsgConfirm: "",
        }
    }

    static getDerivedStateFromProps(props, state) {
        return {
            FavNo: props.FavNo
        }
    }

    handleChangePwd = (e) => {
        try {
            this.showMsg('', 1)
            this.showMsg('', 2)
            this.showMsg('', 3)
            this.setState({ [e.target.name]: e.target.value });
        }
        catch (ex) { }
    }

    PlayAgain = (gameNo) => {
        let gameID = gameNo.split(';').length == 5 ? 9 : 10;
        localStorage.setItem('setfavNo', gameNo);
        if (gameID == 9) {
            history.push('/fortune6');
        }
        else {
            history.push('/super6');
        }
    }

    setErrorMessage = (flagNo, errorstring) => {
        switch (flagNo) {
            case 1:
                this.setState({ ShowErrorMsgCurr: errorstring })
                break;
            case 2:
                this.setState({ ShowErrorMsgNew: errorstring })
                break;
            case 3:
                this.setState({ ShowErrorMsgConfirm: errorstring })
                break;
            default:
                break;
        }
    }


    showMsg = (msg, flagNo) => {
        let errorstring = this.props.t(msg)
        if (flagNo > 0) {
            this.setErrorMessage(flagNo, errorstring)
        }
        else {
            this.props.alertError(errorstring);
        }
    }
    componentDidMount() {

    }
    DeletefavNo = (id) => {
        this.props.DeletefavNo(id, this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey);
        this.state.showdDeleteMsg = true;
    }

    changePwd = (e) => {
        e.preventDefault();
        if (this.state.currentpwd && this.state.newpwd && this.state.confirmpwd && this.state.currentpwd.trim() != "" && this.state.newpwd.trim() != "" && this.state.confirmpwd.trim() != "") {
            if (this.state.currentpwd != this.state.newpwd) {
                if (this.state.newpwd == this.state.confirmpwd) {
                    // let regEx = /^(?=.*?[0-9])(?=.*?[^0-9A-Za-z]).{8,15}$/;
                    let regEx = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,20}$/
                    if (regEx.test(this.state.newpwd) && regEx.test(this.state.confirmpwd)) {
                        this.state.currentpwd = this.state.currentpwd.replace(/'/g, "''");
                        this.state.newpwd = this.state.newpwd.replace(/'/g, "''");
                        this.props.changepassword(this.props.user.mobileNo, this.state.currentpwd, this.state.newpwd, appVariables.PASSWORD_FLAG.ChangePasswordFlag, this.props.i18n.language, this.props.user.loginKey);
                        let tmr = setInterval(
                            () => {
                                if (this.props.Changepassdetails && this.props.Changepassdetails.result && this.props.Changepassdetails.result.Status_id == 0) {
                                    this.setState({ currentpwd: '', newpwd: '', confirmpwd: '' });
                                    clearInterval(tmr);
                                }
                                else if (this.props.Changepassdetails && this.props.Changepassdetails.result && this.props.Changepassdetails.result.Status_id == 1) {
                                    this.setState({ currentpwd: '' });
                                    clearInterval(tmr);
                                }
                            }, 200)
                    }
                    else {
                        this.showMsg('lblReqPasswordPolicy', 2)
                        this.showMsg('lblReqPasswordPolicy', 3)
                        // this.showMsg(this.props.t('lblReqPasswordPolicy'));
                    }
                }
                else {
                    this.showMsg('lblPwdMismatch', 2)
                    this.showMsg('lblPwdMismatch', 3)
                    // this.showMsg(this.props.t('lblPwdMismatch'));
                }
            }
            else {
                this.showMsg('lblCurrandNewPwdSame', 1)
                this.showMsg('lblCurrandNewPwdSame', 2)
                // this.showMsg(this.props.t('lblCurrandNewPwdSame'));
            }
        }
        else {
            this.showMsg('lblPleaseFillDet', 1)
            this.showMsg('lblPleaseFillDet', 2)
            this.showMsg('lblPleaseFillDet', 3)
            // this.showMsg(this.props.t('lblPleaseFillDet'));
        }
    }


    render() {
        const { t } = this.props;
        let myFavNo = this.state.FavNo;
        if (this.state.creditStatus != 0 && this.state.FavNo) {
            if (this.state.creditStatus == 1)
                myFavNo = this.state.FavNo.filter((x) => x.numbers.split(';').length == 5);
            else
                myFavNo = this.state.FavNo.filter((x) => x.numbers.split(';').length == 6);
        }
        let IsErrorMsgCurr = this.state.ShowErrorMsgCurr.length > 0;
        let IsErrorMsgNew = this.state.ShowErrorMsgNew.length > 0;
        let IsErrorMsgConfirm = this.state.ShowErrorMsgConfirm.length > 0;
        return (
            <>
                {
                    process.env.REACT_APP_MODE != "development" && <Helmet>
                        <title>Gulf Ticket : Changepassword</title>
                        <meta name="description" content="Gulf Ticket Changepassword" />
                    </Helmet>
                }
                <div class="myAccContHead">
                    <h1><img src="./assets/img/icons/tabs-profile.png" />{t('lblChangepPwd')}</h1>
                    <div onClick={() => { this.props.kyccontrolfunc(0) }} class="proChangePass"><img src="./assets/img/icons/profile-y.png" /> {t('lblProfile')}</div>
                </div>
                < div className="register myAccProfUpdate" >
                    <div className="registerInr">
                        <p class="subTitle3">{t('lblresetpassquotes')}</p>
                        <form class="register-form" onSubmit={this.changePwd}>
                            <div className="formCont">
                                <label>{t('lblCuurentpwd')}<small className="requiredSymbol">*</small></label>
                                <input className={`${IsErrorMsgCurr ? "errorBorder" : ""}`} type={this.state.showoldpwd ? "text" : "password"} placeholder="********" id="txtCurrentPwd" name="currentpwd" value={this.state.currentpwd} onChange={(e) => this.handleChangePwd(e)} maxLength={20} />
                                {this.state.showoldpwd ? <small id="eyeIcon" value={this.state.currentpwd} class="eyeIcon eyeOpen" onClick={() => this.setState({ showoldpwd: false })}></small> :
                                    <small id="eyeIcon" class="eyeIcon eyeClose" value={this.state.currentpwd} onClick={() => this.setState({ showoldpwd: true })}></small>}
                                {IsErrorMsgCurr && <div class="errorTxt">{this.state.ShowErrorMsgCurr}</div>}
                            </div>
                            <div className="formCont">
                                <label>{t('lblNewPwd')}<small className="requiredSymbol">*</small></label>
                                <input className={`${IsErrorMsgNew ? "errorBorder" : ""}`} type={this.state.shownewpwd ? "text" : "password"} placeholder="********" id="txtNewPwd" name="newpwd" value={this.state.newpwd} onChange={(e) => this.handleChangePwd(e)} maxLength={20} />
                                {this.state.shownewpwd ? <small id="eyeIcon" value={this.state.newpwd} class="eyeIcon eyeOpen" onClick={() => this.setState({ shownewpwd: false })}></small> :
                                    <small id="eyeIcon" class="eyeIcon eyeClose" value={this.state.newpwd} onClick={() => this.setState({ shownewpwd: true })}></small>}
                                {IsErrorMsgNew && <div class="errorTxt">{this.state.ShowErrorMsgNew}</div>}
                            </div>
                            <div className="formCont">
                                <label>{t('lblConfirmpwd')}<small className="requiredSymbol">*</small></label>
                                <input className={`${IsErrorMsgConfirm ? "errorBorder" : ""}`} type={this.state.showconfrimpwd ? "text" : "password"} placeholder="********" id="txtConfirmPwd" name="confirmpwd" value={this.state.confirmpwd} onChange={(e) => this.handleChangePwd(e)} maxLength={20} />
                                {this.state.showconfrimpwd ? <small id="eyeIcon" value={this.state.confirmpwd} class="eyeIcon eyeOpen" onClick={() => this.setState({ showconfrimpwd: false })}></small> :
                                    <small id="eyeIcon" class="eyeIcon eyeClose" value={this.state.confirmpwd} onClick={() => this.setState({ showconfrimpwd: true })}></small>}
                                {IsErrorMsgConfirm && <div class="errorTxt">{this.state.ShowErrorMsgConfirm}</div>}
                            </div>

                            <div class="formCont">
                                {/* opacity */}
                                <button class="margin-top-10" type="submit">{t('lblResetPwd')}</button>
                            </div>
                        </form>
                        {/* <div className="col-md-6 accountSetImg">
                            <div className="walletCusImage">
                                <img src="./assets/img/account-set.webp" />
                            </div>
                        </div> */}
                        <div class="formContError1 margin-top-30">
                            <div class="passInfo">{t('lblpassrule')}</div>
                            <ul>
                                <li>{t('lblpassruleone')}</li>
                                <li>{t('lblpassruletwo')}</li>
                                <li>{t('lblpassrulethree')}</li>
                                <li>{t('lblpassrulefour')}</li>
                            </ul>
                        </div>
                    </div>
                </div >
            </>
        );
    }
}
function mapStateToProps(state) {
    const { user, Changepassdetails } = state.loginReducer;
    const { FavNo, ObjDeleteFavNo } = state.gameReducer;
    return { user, FavNo, ObjDeleteFavNo, Changepassdetails };
}
const mapActionToProps = {
    alertError: alertActions.error,
    changepassword: loginActions.changepassword,
    BackFromCart: gameActions.BackFromCart,
    DeletefavNo: gameActions.DeletefavNo
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(Changepassword))